import Partition from '@commons/partition'
import ProfileInfos from './infos'

const DoctorProfileDetailsPage = () => {
  return <Partition LeftComponent={ProfileInfos} />
}

export default DoctorProfileDetailsPage
